/*
* Palo Alto Theme - custom JS (SOLA)
*
* 1. Cupom de desconto no cart drawer, atualizando em tempo real.
* 2. Setas do carrossel de upsell.
* 3. Contador de itens no icone do header.
*
* Sobre o cupom: aplicar usa /discount/<code>, rota propria da Shopify.
* Remover usa POST /cart/update.js com discount vazio - testado contra a
* loja e confirmado. Os codigos desta loja chegam como line level
* discount allocations, nao cart level, entao o total vem de
* cart.total_discount.
*/

(function () {
  'use strict';

  /* Chave de diagnostico. Abrir qualquer pagina com ?sola=off desliga este
     arquivo por completo, sem alterar nada no tema. Serve para separar em
     um unico teste o que e comportamento do tema/app e o que e codigo SOLA. */
  if (/[?&]sola=off\b/.test(window.location.search)) return;

  var TEXT = {
    empty: 'Digite um cupom.',
    applying: 'Aplicando...',
    removing: 'Removendo...',
    invalid: 'Cupom invalido ou nao aplicavel a este carrinho.',
    failed: 'Nao foi possivel processar. Tente de novo.'
  };

  var SECTION_URL = '/?section_id=api-cart-items';

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */

  function setMessage(root, text) {
    if (!root) return;
    var el = root.querySelector('[data-sola-coupon-msg]');
    if (el) el.textContent = text || '';
  }

  function busy(root, state) {
    if (root) root.classList.toggle('is-loading', !!state);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  /* Re-renders only the cart regions that a coupon can change. The upsell
     holder is deliberately left alone: swapping it would drop the flickity
     instance the theme booted, killing the dots and the arrows. */
  function refreshCartRegions() {
    return fetch(SECTION_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        [
          ['[data-api-line-items]', '[data-items-holder]'],
          ['[data-api-cart-price]', '[data-cart-price-holder]']
        ].forEach(function (pair) {
          var source = doc.querySelector(pair[0]);
          var target = document.querySelector(pair[1]);
          if (source && target) target.innerHTML = source.innerHTML;
        });

      });
  }

  /* ------------------------------------------------------------------ */
  /* Cupom                                                               */
  /* ------------------------------------------------------------------ */

  function applyCoupon(root) {
    if (!root) return;

    var input = root.querySelector('[data-sola-coupon-input]');
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      setMessage(root, TEXT.empty);
      input.focus();
      return;
    }

    busy(root, true);
    setMessage(root, TEXT.applying);

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(getCart)
      .then(function (cart) {
        var wanted = code.toUpperCase();
        var match = (cart.discount_codes || []).filter(function (entry) {
          return (entry.code || '').toUpperCase() === wanted;
        })[0];

        if (!match || !match.applicable) {
          busy(root, false);
          setMessage(root, TEXT.invalid);
          return null;
        }

        return refreshCartRegions();
      })
      .catch(function () {
        busy(root, false);
        setMessage(root, TEXT.failed);
      });
  }

  function removeCoupon(root) {
    if (!root) return;

    busy(root, true);
    setMessage(root, TEXT.removing);

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () { return refreshCartRegions(); })
      .catch(function () {
        busy(root, false);
        setMessage(root, TEXT.failed);
      });
  }

  /* ------------------------------------------------------------------ */
  /* Setas do upsell                                                     */
  /* ------------------------------------------------------------------ */

  function moveUpsell(button, direction) {
    var scope = button.closest('.cart__pair') || document;
    var slider = scope.querySelector('[data-pair-products]');

    if (slider && window.Flickity && typeof window.Flickity.data === 'function') {
      var instance = window.Flickity.data(slider);
      if (instance) {
        if (direction > 0) instance.next(true);
        else instance.previous(true);
        return;
      }
    }

    /* Fallback without touching the flickity API: click the neighbour dot. */
    var dots = scope.querySelectorAll('.flickity-page-dots .dot');
    if (!dots.length) return;

    var current = 0;
    for (var i = 0; i < dots.length; i++) {
      if (dots[i].classList.contains('is-selected')) {
        current = i;
        break;
      }
    }

    dots[(current + direction + dots.length) % dots.length].click();
  }

  /* ------------------------------------------------------------------ */
  /* Contador de itens no header                                         */
  /* ------------------------------------------------------------------ */

  function paintCartCount(count) {
    var badges = document.querySelectorAll('[data-sola-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      badges[i].classList.toggle('is-empty', !count);
    }
  }

  var countTimer = null;
  function refreshCartCount() {
    window.clearTimeout(countTimer);
    countTimer = window.setTimeout(function () {
      getCart()
        .then(function (cart) { paintCartCount(cart.item_count); })
        .catch(function () {});
    }, 120);
  }

  /* Any cart mutation, whoever fires it, repaints the badge. */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var result = nativeFetch.apply(this, arguments);
      try {
        var first = arguments[0];
        var url = typeof first === 'string' ? first : (first && first.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          result.then(refreshCartCount).catch(function () {});
        }
      } catch (err) {
        /* never let instrumentation break a real request */
      }
      return result;
    };
  }

  /* ------------------------------------------------------------------ */
  /* Continuar comprando                                                 */
  /* ------------------------------------------------------------------ */

  function closeCartDrawer() {
    var close = document.querySelector('#cart-drawer [data-cart-drawer-toggle]');
    if (close) {
      close.click();
      return;
    }
    document.body.classList.remove('js-drawer-open-cart');
  }

  function continueShopping() {
    /* Apenas fecha o drawer e devolve o cliente para a pagina que ja estava
       aberta atras dele. Uma versao anterior chamava history.back(), o que
       levava para a pagina ANTERIOR do historico - normalmente o produto que
       ele acabara de adicionar. Nao e o que se espera de "continuar
       comprando": o certo e nao navegar para lugar nenhum. */
    closeCartDrawer();
  }

  /* ------------------------------------------------------------------ */
  /* Bindings                                                            */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var apply = event.target.closest('[data-sola-coupon-apply]');
    if (apply) {
      event.preventDefault();
      applyCoupon(apply.closest('[data-sola-coupon]'));
      return;
    }

    var remove = event.target.closest('[data-sola-coupon-remove]');
    if (remove) {
      event.preventDefault();
      removeCoupon(remove.closest('[data-sola-coupon]'));
      return;
    }

    var prev = event.target.closest('[data-sola-upsell-prev]');
    if (prev) {
      event.preventDefault();
      moveUpsell(prev, -1);
      return;
    }

    var next = event.target.closest('[data-sola-upsell-next]');
    if (next) {
      event.preventDefault();
      moveUpsell(next, 1);
      return;
    }

    var keepShopping = event.target.closest('[data-sola-continue]');
    if (keepShopping) {
      event.preventDefault();
      continueShopping();
    }
  });

  /* The coupon input sits inside [data-cart-form]: Enter would fire checkout. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!(event.target instanceof Element)) return;

    var input = event.target.closest('[data-sola-coupon-input]');
    if (!input) return;

    event.preventDefault();
    applyCoupon(input.closest('[data-sola-coupon]'));
  });

  function boot() {
    refreshCartCount();

    var drawer = document.getElementById('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(refreshCartCount).observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
/*
* SOLA - Visualizacao rapida: campos obrigatorios do app.
*
* Os campos obrigatorios desta loja (envio/retirada e data de entrega) nao
* existem no HTML servido: o buunto-date-picker.js os constroi no cliente.
*
* O app tem uma ancora oficial: ele faz getElementById('buunto-date-picker')
* e, se achar, renderiza DENTRO desse elemento em vez de escolher o lugar
* sozinho. A folha de estilo dele ainda esconde qualquer instancia que fique
* fora dessa ancora, entao mover o widget na mao nunca ia funcionar bem.
*
* Aqui o id e ligado no slot do popup (snippets/product.liquid) somente
* enquanto a visualizacao rapida esta aberta. Ao fechar o id sai, para nao
* roubar a ancora que o app cria no carrinho.
*
* Um pedido sem data de entrega e inaceitavel para uma floricultura, entao o
* padrao continua sendo falhar fechado: o botao de adicionar nasce bloqueado
* e so libera quando o widget do app aparece de fato dentro do popup. Se nao
* aparecer, o botao vira um link para a pagina do produto.
*/

(function () {
  'use strict';

  /* Chave de diagnostico. Abrir qualquer pagina com ?sola=off desliga este
     arquivo por completo, sem alterar nada no tema. Serve para separar em
     um unico teste o que e comportamento do tema/app e o que e codigo SOLA. */
  if (/[?&]sola=off\b/.test(window.location.search)) return;

  var POPUP = '.popup-quick-view';
  var SLOT = '[data-sola-app-slot]';
  var WIDGET = '.buunto-date-picker';
  var ANCHOR_ID = 'buunto-date-picker';
  var VISIBLE_CLASS = 'js-quick-view-visible';

  var WAIT_MS = 8000;
  var POLL_MS = 200;

  var LABEL_MORE = 'Ver descricao completa';
  var LABEL_LESS = 'Ver menos';

  var MAX_MOVES = 5;

  /* Escrever textContent troca o no de texto, ou seja, e mutacao de
     childList: reescrever o mesmo rotulo a cada varredura realimentava o
     MutationObserver e travava a aba. */
  function setLabel(node, text) {
    if (node.textContent !== text) node.textContent = text;
  }

  function popupOpen() {
    return document.body.classList.contains(VISIBLE_CLASS);
  }

  /* Widget renderizado de verdade, nao so a casca do slot: o proprio slot
     passa a ter id "buunto-date-picker", entao procurar por "buunto" no id
     liberaria o botao mesmo sem campo nenhum na tela. */
  function widgetReady(popup) {
    var widget = popup.querySelector(WIDGET);
    return !!(widget && widget.children.length > 0);
  }

  function appHasErrors() {
    var picker = window.Buunto && window.Buunto.datePicker;
    if (!picker || typeof picker.hasErrors !== 'function') return false;
    try {
      return !!picker.hasErrors();
    } catch (err) {
      return false;
    }
  }

  function mountAnchor(popup) {
    var slot = popup.querySelector(SLOT);
    if (!slot) return;

    var existing = document.getElementById(ANCHOR_ID);

    if (!existing) {
      slot.id = ANCHOR_ID;
      return;
    }

    if (existing === slot) return;

    /* JA ESTA NO LUGAR. Esta linha e a diferenca entre funcionar e travar a
       aba: mover um no dispara o MutationObserver, que chama esta funcao de
       novo. Sem esta saida, appendChild de um filho que ja e o ultimo ainda
       conta como mutacao e o laco nunca fecha. */
    if (slot.contains(existing)) return;

    /* Ancora fora do popup (carrinho): nao se disputa o id. */
    if (!popup.contains(existing)) return;

    /* Teto de seguranca, independente da idempotencia acima. */
    var moves = parseInt(slot.getAttribute('data-sola-moves') || '0', 10);
    if (moves >= MAX_MOVES) return;
    slot.setAttribute('data-sola-moves', moves + 1);

    slot.appendChild(existing);
  }

  function unmountAnchor() {
    var slots = document.querySelectorAll(SLOT);
    var removed = false;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].id === ANCHOR_ID) {
        slots[i].removeAttribute('id');
        removed = true;
      }
    }
    return removed;
  }

  /* Sem o carrinho deslizante o app nao liga o loop de 500ms que reprocessa
     a pagina (ele so faz isso quando detecta cart drawer). Como a
     visualizacao rapida e inserida depois do carregamento, ele nao a
     perceberia sozinho. refreshWidget e a API publica do proprio app para
     mandar reprocessar. */
  function refreshApp() {
    var picker = window.Buunto && window.Buunto.datePicker;
    if (!picker || typeof picker.refreshWidget !== 'function') return;
    try {
      picker.refreshWidget(false, true);
    } catch (err) {
      /* nunca deixar a integracao derrubar o popup */
    }
  }

  /* O HTML da visualizacao rapida chega por fetch e e injetado com
     innerHTML, e o navegador NAO executa <script> inserido assim. O bloco
     "Este pedido e um presente?" depende do proprio script para aparecer
     (nasce com opacity: 0) e para validar. Reinserir o no faz o navegador
     executa-lo. Os <script type="application/json"> do tema sao dados, nao
     codigo, e ficam de fora. */
  function runInlineScripts(popup) {
    var scripts = popup.querySelectorAll('script:not([data-sola-ran])');

    for (var i = 0; i < scripts.length; i++) {
      var node = scripts[i];
      var type = (node.getAttribute('type') || '').toLowerCase();

      if (type && type !== 'text/javascript' && type !== 'application/javascript') continue;

      node.setAttribute('data-sola-ran', '');

      var fresh = document.createElement('script');
      /* Marcar o clone tambem, senao a proxima varredura o encontra como
         "ainda nao executado" e roda de novo. O script do presente comeca
         com box.checked = false, entao reexecutar a cada mudanca do DOM
         desmarcava o "Sim" no mesmo instante em que o cliente clicava. */
      fresh.setAttribute('data-sola-ran', '');
      if (node.src) {
        fresh.src = node.src;
      } else {
        fresh.textContent = node.textContent;
      }
      node.parentNode.insertBefore(fresh, node.nextSibling);
    }
  }

  /* Descricao completa sem empurrar envio/data/botao para fora da tela. */
  function setupDescription(popup) {
    var desc = popup.querySelector('[data-sola-desc]');
    var more = popup.querySelector('[data-sola-desc-more]');
    if (!desc || !more) return;

    if (!more.hasAttribute('data-sola-ready')) {
      more.setAttribute('data-sola-ready', '');
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        setLabel(more, open ? LABEL_LESS : LABEL_MORE);
      });
    }

    if (desc.classList.contains('is-open')) return;

    if (desc.scrollHeight > desc.clientHeight + 4) {
      setLabel(more, LABEL_MORE);
      more.hidden = false;
    } else {
      more.hidden = true;
    }
  }

  function degrade(popup, button) {
    var link = popup.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : null;
    if (!href) {
      /* Sem URL nao da para oferecer saida: solta o botao e deixa o app do
         carrinho reclamar, em vez de travar o cliente numa tela morta. */
      button.removeAttribute('data-sola-atc-locked');
      return;
    }

    var holder = button.parentNode;
    if (!holder) return;

    button.style.display = 'none';

    var fallback = document.createElement('a');
    fallback.className = 'sola-qv-fallback';
    fallback.href = href;
    fallback.textContent = 'Escolher data e finalizar';
    holder.appendChild(fallback);

    var note = document.createElement('p');
    note.className = 'sola-qv-note';
    note.textContent = 'A escolha de envio e data acontece na pagina do produto.';
    holder.appendChild(note);
  }

  function guard(popup) {
    if (popup.hasAttribute('data-sola-guarded')) return;
    popup.setAttribute('data-sola-guarded', '');

    refreshApp();

    var button = popup.querySelector('[data-add-to-cart]');
    if (button) button.setAttribute('data-sola-atc-locked', '');

    var deadline = Date.now() + WAIT_MS;

    (function poll() {
      if (!document.body.contains(popup)) return;

      mountAnchor(popup);
      runInlineScripts(popup);
      setupDescription(popup);

      if (widgetReady(popup)) {
        if (button) button.removeAttribute('data-sola-atc-locked');
        return;
      }

      if (Date.now() > deadline) {
        if (button) degrade(popup, button);
        return;
      }

      window.setTimeout(poll, POLL_MS);
    })();
  }

  /* Fase de captura: roda antes do handler do tema, entao consegue barrar. */
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest(POPUP + ' [data-add-to-cart]')) return;
    if (!appHasErrors()) return;

    event.preventDefault();
    event.stopPropagation();
  }, true);

  function reset() {
    var popups = document.querySelectorAll(POPUP);
    for (var i = 0; i < popups.length; i++) {
      /* O tema reaproveita o mesmo elemento do popup na proxima abertura,
         entao a trava precisa poder ser armada de novo. */
      popups[i].removeAttribute('data-sola-guarded');

      /* O tema reaproveita o elemento do popup, entao o formulario do ultimo
         produto continua no DOM depois de fechar. Sem tirar o sufixo, o
         buunto-date-picker continuaria enxergando esse formulario escondido
         como "o formulario do produto" da pagina. */
      var form = popups[i].querySelector('form[id$="__main"]');
      if (form) form.id = form.id.replace(/__main$/, '');
    }

    /* So reprocessa quando a ancora realmente saiu: chamar a cada varredura
       seria mais um laco de realimentacao do MutationObserver. */
    if (unmountAnchor()) refreshApp();
  }

  function scan() {
    if (!popupOpen()) {
      reset();
      return;
    }

    var popups = document.querySelectorAll(POPUP);
    for (var i = 0; i < popups.length; i++) {
      guard(popups[i]);

      /* Reforcado a cada mudanca do DOM: o app se re-renderiza sozinho e
         pode recriar a ancora fora do lugar. */
      mountAnchor(popups[i]);
      runInlineScripts(popups[i]);
      setupDescription(popups[i]);
    }
  }

  /* Uma varredura por quadro, no maximo. Rede de protecao estrutural: se
     algum dia uma escrita deixar de ser idempotente, o pior caso passa a ser
     trabalho repetido a 60fps em vez de laco sincrono que congela a aba. */
  var queued = false;

  function scheduleScan() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }

  function boot() {
    scan();
    if (!window.MutationObserver || !window.requestAnimationFrame) return;

    new MutationObserver(scheduleScan).observe(document.body, {
      childList: true,
      subtree: true
    });

    /* O tema marca/desmarca js-quick-view-visible no body ao abrir e fechar. */
    new MutationObserver(scheduleScan).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/*
* SOLA - Newsletter do rodape: levar o cliente ate a confirmacao.
*
* O formulario e o {% form 'customer' %} nativo com
* contact[accepts_marketing] = true, entao o cadastro cai em Clientes na
* dashboard sem precisar de nada a mais. Depois do POST a Shopify devolve
* para a MESMA pagina com ?customer_posted=true, e o tema renderiza o aviso
* de sucesso dentro do proprio formulario - la no rodape.
*
* O problema e que o navegador volta no topo da pagina: a pessoa se inscreve
* e nao ve confirmacao nenhuma. Aqui a tela desce ate o aviso.
*/

(function () {
  'use strict';

  if (/[?&]sola=off\b/.test(window.location.search)) return;
  if (window.location.search.indexOf('customer_posted=true') === -1) return;

  function reveal() {
    var note = document.querySelector('.site-footer .newsletter-form .form-success');
    if (!note) return;

    note.setAttribute('tabindex', '-1');
    note.scrollIntoView({ behavior: 'smooth', block: 'center' });

    /* Leitores de tela anunciam o aviso ao receber foco. */
    try {
      note.focus({ preventScroll: true });
    } catch (err) {
      /* navegador antigo: o scroll acima ja resolve o essencial */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
})();

/*
* SOLA - galeria da pagina de produto acompanhando a rolagem (desktop).
*
* A galeria e um item de grid; para grudar ela precisa de align-self: start
* (senao estica na altura da linha inteira e nao sobra curso para deslizar).
* Isso esta no CSS. O que so da para resolver aqui e o valor de "top":
*
*   - galeria mais BAIXA que a janela  -> top = altura do header + folga,
*     ela gruda logo abaixo do cabecalho;
*   - galeria mais ALTA que a janela   -> top NEGATIVO, calculado para que a
*     base da galeria (miniaturas inclusive) encoste na base da janela. Assim
*     ela sobe junto com a pagina ate se mostrar por inteiro e so entao gruda,
*     em vez de ter o rodape cortado para sempre.
*/
(function () {
  'use strict';

  if (/[?&]sola=off\b/.test(window.location.search)) return;

  var SECTION = '.product-single[data-sola-sticky-gallery="true"]';
  var GALLERY = '.product-single__gallery';
  var GAP = 24;
  var BREAKPOINT = 768;

  function headerOffset() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return 0;

    var position = window.getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;

    return header.offsetHeight || 0;
  }

  function apply() {
    var sections = document.querySelectorAll(SECTION);
    if (!sections.length) return;

    var narrow = window.innerWidth < BREAKPOINT;
    var base = headerOffset() + GAP;

    Array.prototype.forEach.call(sections, function (section) {
      if (narrow) {
        section.style.removeProperty('--sola-gallery-top');
        return;
      }

      var gallery = section.querySelector(GALLERY);
      if (!gallery) return;

      var free = window.innerHeight - gallery.offsetHeight - GAP;
      var top = Math.round(Math.min(base, free));

      section.style.setProperty('--sola-gallery-top', top + 'px');
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  function watch() {
    var sections = document.querySelectorAll(SECTION);
    if (!sections.length) return;

    apply();

    /* A altura muda quando as fotos carregam e quando o Flickity monta o
       carrossel, entao observamos a galeria em vez de medir uma vez so. */
    if (typeof window.ResizeObserver === 'function') {
      var observer = new window.ResizeObserver(schedule);
      Array.prototype.forEach.call(sections, function (section) {
        var gallery = section.querySelector(GALLERY);
        if (gallery) observer.observe(gallery);
      });
    }

    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('theme:resize', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
